import { InfoArticle, ModalParts } from 'BreetComponents';
import { useFundRequestContext, useModalApi } from 'BreetHooks';

import CryptoFundingMethod from './forms/crypto/Crypto';
import FiatFundingMethod from './forms/fiat/Fiat';
import FundingMethod from './FundingMethod';
import Header from './Header';

const Child = () => {
	const { fundingMethod } = useFundRequestContext();

	const { handleModalClose } = useModalApi();

	const isCryptoFundingMethod = fundingMethod === 'Crypto';

	const FundingComponent = isCryptoFundingMethod ? CryptoFundingMethod : FiatFundingMethod;

	return (
		<ModalParts.Wrapper
			title='Fund Wallet'
			root='Fund Wallet'
			rightSheet
			handleBackLink={handleModalClose('fundWallet')}
		>
			<div
				className='payment-request-form withdraw-request-form'
				data-testid='fund-form'
			>
				<Header />

				<FundingMethod />

				{!fundingMethod ? null : <FundingComponent />}

				<InfoArticle
					articleNumber='15830205'
					text='How does funding work?'
				/>
			</div>
		</ModalParts.Wrapper>
	);
};

export default Child;
